
import { Vue, Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Dialog, Toast } from 'vant';
import { RouteMeta } from 'vue-router';
import eventBus from '@/utils/event-bus';
import type { SetNavRightArgs } from '@/utils/event-bus';

@Component({})
export default class Header extends Vue {
  // 定义 data 属性
  isFixed: boolean = true;
  customTitle: NString = ""
  rightButton = {} as any as SetNavRightArgs;

  get showOrder() { return this.pageMeta.showOrder; }

  get title() { return this.customTitle || this.pageMeta.title || "首页" }

  created() {
    eventBus.on("upate-nav-title", (title: string) => {
      this.customTitle = title
    })
    eventBus.on("set-nav-right", (arg: SetNavRightArgs) => {
      this.rightButton = { ...arg }
    })

  }

  beforeDestroy() {
    eventBus.off("upate-nav-title");
    eventBus.off("set-nav-right");
  }
  get headerShow() { return this.$route.meta?.isHeaderShow; }


  get pageMeta() { return this.$route.meta || {} as RouteMeta; }

  @Watch("$route")
  onRouteChanged() {
    // console.error("head onRouteChanged")
    this.customTitle = undefined;
    this.rightButton = {} as any;
  }

  /* 返回上一页*/
  onGoBack() { this.$router.go(-1); }

  /** 跳转到订单页面 */
  async toOrder() {
    await Dialog.confirm({
      message:
        "建议您在电脑上操作以获得更好体验。\n电脑端网址：znlscm.com 。\n如有疑问请致电：0755-82798001，谢谢~",
      confirmButtonText: "复制网址"
    })

    navigator.clipboard.writeText("https://znlscm.com/").then(() => {
      Toast.success("网址已经复制");
    });

    this.$router.push({ name: "OrderEdit", query: {} });

  }
}
